import { Injectable } from '@angular/core';
import { WorkspaceApiService } from '../workspace-api.service';
import { handleApiCallAsync } from '../../../../utils/general-functions';
import { IUpdateWorkspaceRequestBody } from '../../../http-models/workspace/workspace-request-model';
import { IWSContext } from '../../../../models/workspace/workspace-model';
import { IOrgContext } from '../../../../models/organization/organization-model';

@Injectable()
export class WorkspaceApiManagerService {
    private organContext: IOrgContext;
    private wsContext: IWSContext;

    constructor(private workspaceApi: WorkspaceApiService) {}

    createNewWorkspaceAsync(name: string) {
        return handleApiCallAsync(
            this.workspaceApi.createNewWorkspace$(
                {
                    organizationId: this.organContext.organizationId,
                },
                name
            )
        );
    }

    getWorkspaceMetadataAsync(wsId: string) {
        return handleApiCallAsync(
            this.workspaceApi.getWorkspaceMetadata$({
                organizationId: this.organContext.organizationId,
                workspaceId: wsId,
            })
        );
    }

    updateWSFieldAsync(body: IUpdateWorkspaceRequestBody) {
        return handleApiCallAsync(this.workspaceApi.updateWSField$(this.wsContext, body));
    }

    updateWSOrganDefaultIdsAsync() {
        return handleApiCallAsync(this.workspaceApi.updateWSOrganDefaultIds$(this.wsContext));
    }

    public setOrgContext(organContext: IOrgContext) {
        this.organContext = organContext;
    }

    public setWsContext(wsContext: IWSContext) {
        this.wsContext = wsContext;
    }
}
